export const OptionName = [
  { value: 'mobile number', label: 'Mobile Number' },
  { value: 'First Name', label: 'First Name' },
  { value: 'Last Name', label: 'Last Name' },
  { value: 'Full Name', label: 'Full Name' },
  { value: 'Address', label: 'Address' },
  { value: 'Postalcode', label: 'Postal Code' },
  { value: 'Birthday', label: 'Birthday' },
  { value: 'Purchase', label: 'Purchase' },
  { value: 'Email', label: 'Email' },
  { value: 'Tag', label: 'Tag' },
  { value: 'List', label: 'List' },
  { value: 'Gender', label: 'Gender' },
  { value: 'Date of Birth', label: 'Date of Birth' },
  { value: 'Source', label: 'Source' },
  { value: 'Assigned Staff First Name', label: 'Assigned Staff First Name' },
  { value: 'Assigned Staff Last Name', label: 'Assigned Staff Last Name' },
  { value: 'Assigned Staff Email', label: 'Assigned Staff Email' },
  { value: 'Assigned Staff Phone', label: 'Assigned Staff Phone' },
  { value: 'Assigned Company', label: 'Assigned Company' },
];
